import _ from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import {
  Bar,
  BarChart,
  Legend,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";
import Loading from "../Loading";
import { isMobile } from "../../utils";
import { useClients } from "../../contexts/ClientsContext";
import notificationImage from "../../assets/notification.svg";

export const ChartBar = ({ monthReport }: any) => {
  const [data, setDataChart] = useState([]);
  const [bars, setBars] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [totalJscp, setTotalJscp] = useState(0);
  const [totalDiv, setTotalDiv] = useState(0);
  const [totalBonds, setTotalBonds] = useState(0);
  const [totalRendi, setTotalRendi] = useState(0);
  const [totalAmort, setTotalAmort] = useState(0);

  const { proventos, yearProventos, typeProventos } = useClients();

   const chartColors = [
    { background: "#006100", label: "white" },
    { background: "#00BC75", label: "white" },
    { background: "#C7D200", label: "white" },
    { background: "#FBC105", label: "white" },
    { background: "#FF8000", label: "white" },
    { background: "#E50045", label: "white" },
    { background: "#FF2B00", label: "white" },
    { background: "#79002A", label: "white" },
    { background: "#8B5CF6", label: "white" }, 
    { background: "#06B6D4", label: "white" }, 
    { background: "#10B981", label: "white" }, 
    { background: "#F59E0B", label: "white" }, 
    { background: "#EF4444", label: "white" }, 
  ]

  const getProviderColor = (provider: string, index: number) => {
    while (index > 8) {
      const differnce = index - 8;
      index = differnce - 1;
    }
    return chartColors[index].background;
  };

  useEffect(() => {
    setLoading(true);
    let totalJscp = 0;
    let totalDiv = 0;
    let totalBonds = 0;
    let totalRendi = 0;
    let totalAmort = 0;
    if (typeProventos === "provento") {
      const proventoByMonth: any = [
        {
          name: "Jan",
          juros: 0,
          dividendo: 0,
          rendimento: 0,
          amortizacao: 0,
          bonds: 0,
        },
        {
          name: "Fev",
          juros: 0,
          dividendo: 0,
          rendimento: 0,
          amortizacao: 0,
          bonds: 0,
        },
        {
          name: "Mar",
          juros: 0,
          dividendo: 0,
          rendimento: 0,
          amortizacao: 0,
          bonds: 0,
        },
        {
          name: "Abr",
          juros: 0,
          dividendo: 0,
          rendimento: 0,
          amortizacao: 0,
          bonds: 0,
        },
        {
          name: "Mai",
          juros: 0,
          dividendo: 0,
          rendimento: 0,
          amortizacao: 0,
          bonds: 0,
        },
        {
          name: "Jun",
          juros: 0,
          dividendo: 0,
          rendimento: 0,
          amortizacao: 0,
          bonds: 0,
        },
        {
          name: "Jul",
          juros: 0,
          dividendo: 0,
          rendimento: 0,
          amortizacao: 0,
          bonds: 0,
        },
        {
          name: "Ago",
          juros: 0,
          dividendo: 0,
          rendimento: 0,
          amortizacao: 0,
          bonds: 0,
        },
        {
          name: "Set",
          juros: 0,
          dividendo: 0,
          rendimento: 0,
          amortizacao: 0,
          bonds: 0,
        },
        {
          name: "Out",
          juros: 0,
          dividendo: 0,
          rendimento: 0,
          amortizacao: 0,
          bonds: 0,
        },
        {
          name: "Nov",
          juros: 0,
          dividendo: 0,
          rendimento: 0,
          amortizacao: 0,
          bonds: 0,
        },
        {
          name: "Dez",
          juros: 0,
          dividendo: 0,
          rendimento: 0,
          amortizacao: 0,
          bonds: 0,
        },
      ];

      const groupedProventos = _.groupBy(proventos, (item) => {
        return moment(item.date).format("YYYY-MM");
      });

      for (const key in groupedProventos) {
        const year = +moment(key).format("Y");
        const month = +moment(key).format("M");
        const operations = groupedProventos[key];
        if (Number(year) === yearProventos) {
          operations.forEach((el: any) => {
            if (
              el?.corporateActionTypeDescription?.toLowerCase() === "rendimento"
            ) {
              proventoByMonth[month - 1].rendimento =
                proventoByMonth[month - 1]?.rendimento + el.grossAmount;
            }
            if (
              el?.corporateActionTypeDescription?.toLowerCase() ===
                "dividendo" ||
              el?.corporateActionTypeDescription?.toLowerCase() === "dividendos"
            ) {
              proventoByMonth[month - 1].dividendo =
                proventoByMonth[month - 1]?.dividendo + el.grossAmount;
            }
            if (
              el?.corporateActionTypeDescription?.toLowerCase() ===
              "juros sobre capital próprio"
            ) {
              proventoByMonth[month - 1].juros =
                proventoByMonth[month - 1]?.juros + el.grossAmount;
            }
            if (
              el?.corporateActionTypeDescription?.toLowerCase() ===
              "amortização"
            ) {
              proventoByMonth[month - 1].amortizacao =
                proventoByMonth[month - 1]?.amortizacao + el.grossAmount;
            }
            if (el?.corporateActionTypeDescription?.toLowerCase() === "cupom") {
              proventoByMonth[month - 1].bonds =
                proventoByMonth[month - 1]?.bonds + el.grossAmount;
            }
          });
        }
      }
      for (const el of proventoByMonth) {
        totalAmort += el.amortizacao || 0;
        totalJscp += el.juros || 0;
        totalDiv += el.dividendo || 0;
        totalBonds += el.bonds || 0;
        totalRendi += el.rendimento || 0;
      }

      setTotalAmort(totalAmort);
      setTotalBonds(totalBonds);
      setTotalDiv(totalDiv);
      setTotalJscp(totalJscp);
      setTotalRendi(totalRendi);
      setDataChart(proventoByMonth);
    }
    if (typeProventos === "corretora") {
      const proventoByMonth: any = [
        {
          name: "Jan",
        },
        {
          name: "Fev",
        },
        {
          name: "Mar",
        },
        {
          name: "Abr",
        },
        {
          name: "Mai",
        },
        {
          name: "Jun",
        },
        {
          name: "Jul",
        },
        {
          name: "Ago",
        },
        {
          name: "Set",
        },
        {
          name: "Out",
        },
        {
          name: "Nov",
        },
        {
          name: "Dez",
        },
      ];
      const barsChart: any = [];

      const groupedProventos = _.groupBy(proventos, (item) => {
        return item.corretora;
      });

      for (const key in groupedProventos) {
        barsChart.push(key);
        const operations = groupedProventos[key];
        operations.forEach((el: any) => {
          if (Number(moment(el.date).format("YYYY")) === yearProventos) {
            const month = Number(moment(el.date).format("M"));
            if (
              el?.corporateActionTypeDescription?.toLowerCase() === "rendimento"
            ) {
              proventoByMonth[month - 1][key] =
                (proventoByMonth[month - 1][key] || 0) + el.grossAmount;
            }
            if (
              el?.corporateActionTypeDescription?.toLowerCase() ===
                "dividendo" ||
              el?.corporateActionTypeDescription?.toLowerCase() === "dividendos"
            ) {
              proventoByMonth[month - 1][key] =
                (proventoByMonth[month - 1][key] || 0) + el.grossAmount;
            }
            if (
              el?.corporateActionTypeDescription?.toLowerCase() ===
              "juros sobre capital próprio"
            ) {
              proventoByMonth[month - 1][key] =
                (proventoByMonth[month - 1][key] || 0) + el.grossAmount;
            }
            if (
              el?.corporateActionTypeDescription?.toLowerCase() ===
              "amortização"
            ) {
              proventoByMonth[month - 1][key] =
                (proventoByMonth[month - 1][key] || 0) + el.grossAmount;
            }
            if (el?.corporateActionTypeDescription?.toLowerCase() === "cupom") {
              proventoByMonth[month - 1][key] =
                (proventoByMonth[month - 1][key] || 0) + el.grossAmount;
            }
          }
        });
      }

      setBars(barsChart);
      setDataChart(proventoByMonth);
    }
    if (typeProventos === "data") {
      const proventoByMonth: any = [
        {
          name: "Jan",
          futuro: 0,
          liquidado: 0,
        },
        {
          name: "Fev",
          futuro: 0,
          liquidado: 0,
        },
        {
          name: "Mar",
          futuro: 0,
          liquidado: 0,
        },
        {
          name: "Abr",
          futuro: 0,
          liquidado: 0,
        },
        {
          name: "Mai",
          futuro: 0,
          liquidado: 0,
        },
        {
          name: "Jun",
          futuro: 0,
          liquidado: 0,
        },
        {
          name: "Jul",
          futuro: 0,
          liquidado: 0,
        },
        {
          name: "Ago",
          futuro: 0,
          liquidado: 0,
        },
        {
          name: "Set",
          futuro: 0,
          liquidado: 0,
        },
        {
          name: "Out",
          futuro: 0,
          liquidado: 0,
        },
        {
          name: "Nov",
          futuro: 0,
          liquidado: 0,
        },
        {
          name: "Dez",
          futuro: 0,
          liquidado: 0,
        },
      ];
      const types = [
        "rendimento",
        "juros sobre capital próprio",
        "dividendo",
        "dividendos",
        "amortização",
        "cupom",
      ];

      proventos.forEach((el: any) => {
        const year = Number(moment(el.date).format("Y"));
        if (
          year === yearProventos &&
          types.includes(el.corporateActionTypeDescription.toLowerCase())
        ) {
          const month = Number(moment(el.date).format("M"));
          if (el.isFuturo) {
            proventoByMonth[month - 1].futuro += el.grossAmount;
          } else {
            proventoByMonth[month - 1].liquidado += el.grossAmount;
          }
        }
      });
      setDataChart(proventoByMonth);
    }

    setLoading(false);
  }, [yearProventos, proventos, typeProventos]);

  const renderLegend = (value: string, entry: any) => {
    return <span style={{ color: "black", fontWeight: 400 }}>{value}</span>;
  };

  const labelFormatter = (value: any) => {
    return value > 0
      ? "R$ " +
          value?.toLocaleString("pt-br", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
      : "";
  };

  const renderTooltip = (value: any) => {
    const { payload } = value;
    if (typeProventos === "provento") {
      const total =
        payload[0]?.payload?.dividendo +
        payload[0]?.payload?.rendimento +
        payload[0]?.payload?.juros +
        payload[0]?.payload?.amortizacao;
      return payload[0]?.payload?.dividendo > 0 ||
        payload[0]?.payload?.rendimento > 0 ||
        payload[0]?.payload?.juros > 0 ||
        payload[0]?.payload?.amortizacao > 0 ||
        payload[0]?.payload?.bonds > 0 ? (
        <div className="container-tooltip">
          {payload[0]?.payload?.dividendo > 0 && (
            <span style={{ fontSize: "12px" }}>
              Dividendos: R${" "}
              {payload[0]?.payload?.dividendo.toLocaleString("pt-br", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}{" "}
              (
              {total > 0
                ? ((payload[0]?.payload?.dividendo * 100) / total).toFixed(2)
                : 0}
              %)
            </span>
          )}
          {payload[0]?.payload?.rendimento > 0 && (
            <span style={{ fontSize: "12px" }}>
              Rendimento: R${" "}
              {payload[0]?.payload?.rendimento.toLocaleString("pt-br", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}{" "}
              (
              {total > 0
                ? ((payload[0]?.payload?.rendimento * 100) / total).toFixed(2)
                : 0}
              %)
            </span>
          )}
          {payload[0]?.payload?.juros > 0 && (
            <span style={{ fontSize: "12px" }}>
              Juros sobre capital próprio: R${" "}
              {payload[0]?.payload?.juros.toLocaleString("pt-br", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}{" "}
              (
              {total > 0
                ? ((payload[0]?.payload?.juros * 100) / total).toFixed(2)
                : 0}
              %)
            </span>
          )}
          {payload[0]?.payload?.amortizacao > 0 && (
            <span style={{ fontSize: "12px" }}>
              Amortização: R${" "}
              {payload[0]?.payload?.amortizacao.toLocaleString("pt-br", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}{" "}
              (
              {total > 0
                ? ((payload[0]?.payload?.amortizacao * 100) / total).toFixed(2)
                : 0}
              %)
            </span>
          )}
          {payload[0]?.payload?.bonds > 0 && (
            <span style={{ fontSize: "12px" }}>
              Cupom: R${" "}
              {payload[0]?.payload?.bonds.toLocaleString("pt-br", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}{" "}
              (
              {total > 0
                ? ((payload[0]?.payload?.bonds * 100) / total).toFixed(2)
                : 0}
              %)
            </span>
          )}
        </div>
      ) : (
        <></>
      );
    }
    if (typeProventos === "corretora") {
      const keys = Object.keys(payload[0]?.payload || {});
      let total = 0;
      keys.forEach((el) => {
        if (el !== "name") {
          total += payload[0]?.payload[el] || 0;
        }
      });

      return (
        <div className="container-tooltip">
          {keys.map((el) => {
            if (el !== "name") {
              return (
                <span style={{ fontSize: "12px" }}>
                  {el}: R${" "}
                  {payload[0]?.payload[el].toLocaleString("pt-br", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}{" "}
                  (
                  {total > 0
                    ? ((payload[0]?.payload[el] * 100) / total).toFixed(2)
                    : 0}
                  %)
                </span>
              );
            }
            return <></>;
          })}
        </div>
      );
    }
    if (typeProventos === "data") {
      const total =
        payload[0]?.payload?.futuro + payload[0]?.payload?.liquidado;
      return total > 0 ? (
        <div className="container-tooltip">
          <span style={{ fontSize: "12px" }}>
            Futuro: R${" "}
            {payload[0]?.payload?.futuro.toLocaleString("pt-br", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}{" "}
            (
            {total > 0
              ? ((payload[0]?.payload?.futuro * 100) / total).toFixed(2)
              : 0}
            %)
          </span>
          <span style={{ fontSize: "12px" }}>
            Liquidado: R${" "}
            {payload[0]?.payload?.liquidado.toLocaleString("pt-br", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}{" "}
            (
            {total > 0
              ? ((payload[0]?.payload?.liquidado * 100) / total).toFixed(2)
              : 0}
            %)
          </span>
        </div>
      ) : (
        <></>
      );
    }
  };

  return loading ? (
    <Loading />
  ) : data.filter((i: any) =>
      typeProventos === "provento"
        ? i.amortizacao + i.bonds + i.dividendo + i.juros + i.rendimento > 0
        : typeProventos === "data"
        ? i.futuro + i.liquidado > 0
        : Object.keys(i)
            .filter((key) => key !== "name")
            .reduce((a, c) => a + i[c], 0) > 0
    ).length === 0 ? (
    <div className="empty-data">
      <img src={notificationImage} alt="Notificações" />
      <p>O seu cliente não recebeu proventos neste período</p>
    </div>
  ) : (
    <ResponsiveContainer width="100%" height="80%">
      <BarChart
        data={data}
        margin={{
          top: 50,
          left: -60,
        }}
      >
        <XAxis dataKey="name" style={{ fontSize: "10px" }} />
        <YAxis axisLine={false} tick={false} />
        <Tooltip content={renderTooltip} />
        <Legend
          style={{ color: "black" }}
          align="center"
          layout="horizontal"
          iconType="circle"
          verticalAlign="bottom"
          formatter={renderLegend}
        />
        {typeProventos === "provento" && (
          <>
            {totalJscp > 0 && (
              <Bar
                dataKey="juros"
                stackId="a"
                fill="var(--ant-error-color-active)"
                name="Juros sobre capital próprio"
                onClick={monthReport}
              />
            )}
            {totalRendi > 0 && (
              <Bar
                dataKey="rendimento"
                stackId="a"
                fill="#ff7a00"
                name="Rendimento"
                onClick={monthReport}
              />
            )}
            {totalDiv > 0 && (
              <Bar
                dataKey="dividendo"
                stackId="a"
                fill="var(--ant-primary-color)"
                name="Dividendo"
                onClick={monthReport}
              />
            )}
            {totalAmort > 0 && (
              <Bar
                dataKey="amortizacao"
                stackId="a"
                fill="#4B0082"
                name="Amortização"
                onClick={monthReport}
              />
            )}
            {totalBonds > 0 && (
              <Bar
                dataKey="bonds"
                stackId="a"
                fill="#CC13AF"
                name="Cupom"
                onClick={monthReport}
              />
            )}
            {!isMobile() && (
              <Bar
                dataKey=""
                stackId="a"
                fill="transparent"
                name=""
                label={{ position: "top", formatter: labelFormatter }}
              />
            )}
          </>
        )}
        {typeProventos === "corretora" && (
          <>
            {bars.map((el, index) => {
              return (
                <Bar
                  dataKey={el}
                  stackId="a"
                  fill={getProviderColor("", index)}
                  name={el}
                  onClick={monthReport}
                />
              );
            })}
            {!isMobile() && (
              <Bar
                dataKey=""
                stackId="a"
                fill="transparent"
                name=""
                label={{ position: "top", formatter: labelFormatter }}
              />
            )}
          </>
        )}
        {typeProventos === "data" && (
          <>
            <Bar
              dataKey="futuro"
              stackId="a"
              fill="var(--ant-error-color-active)"
              onClick={monthReport}
              name="Futuro"
            />
            <Bar
              dataKey="liquidado"
              stackId="a"
              fill="#ff7a00"
              name="Liquidado"
              onClick={monthReport}
            />
            {!isMobile() && (
              <Bar
                dataKey=""
                stackId="a"
                fill="transparent"
                name=""
                label={{ position: "top", formatter: labelFormatter }}
              />
            )}
          </>
        )}
      </BarChart>
    </ResponsiveContainer>
  );
};
